export default __webpack_public_path__ + "static/media/10.5436a8d5.webp";